import script from "./ActionMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionMenu.vue?vue&type=script&lang=ts&setup=true"

import "./ActionMenu.vue?vue&type=style&index=0&id=1d027dfc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d027dfc"]])

export default __exports__